// Reference: https://stackblitz.com/edit/search-json-example?file=LocationInfo.json

import { useState, useEffect } from "react";
import TournamentsTable from './TournamentsTable'
import BuyInFilter from './BuyInFilter'
import SearchForm from './SearchForm'

let path
if(window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    path = 'http://localhost/vs/pokerkamers.nl/wordpress/'
} else {
    path = 'https://www.pokerkamers.nl/'
}

const App = () => {
    const [data, setData] = useState({ pokerSites: {}, tournaments: [], allTournaments: [] })
    const [filter, setFilter] = useState({ buyInRange: 0, searchStr: '' })
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        fetch(path + 'wp-json/pokerkamers/pokersites/')
        .then(response => response.json())
        .then(result => {
            setData( data => ({...data, pokerSites: result }) );
        })
        .catch((error) => {
            console.error("Error fetching data: ", error)
            setError(error)
        })
        .finally(() => {
            setLoading(false)
        });
    }, [])

    useEffect(() => {
        fetch(path + 'wp-content/json/tournament_schedule.json')
        .then(response => response.json())
        .then(result => {
            setData( data => ({...data, tournaments: result.tournaments, allTournaments: result.tournaments }) );
        })
        .catch((error) => {
            console.error("Error fetching data: ", error);
            setError(error)
        })
        .finally(() => {
            setLoading(false)
        });
    }, [])

    if (loading) return "Loading..."
    if (error) return "Error!"

    const filterTournaments = (buyInRange) => {
        setFilter( filter => ({...filter, buyInRange: 0, searchStr: '' }) );
        if(buyInRange > 0) {
            setData(
                data => ({...data, tournaments: data.allTournaments.filter(
                        item => { return item.buy_in <= buyInRange }
                    )
                })
            )
        } else {
            setData(
                data => ({...data, tournaments: data.allTournaments })
            )
        }
    }

    const handleSearch = (event) => {
        setFilter( filter => ({...filter, searchStr: event.target.value }) );
        if(event.target.value !== '') {
            setData(
                data => ({...data, tournaments: data.allTournaments.filter(
                       item => { return item.name.toLowerCase().includes(filter.searchStr.toLowerCase()) }
                    )
                })
            )
        } else {
            setData(
                data => ({...data, tournaments: data.allTournaments })
            )
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
    }

    return (
        <div>
            <div className="row">
                <div className="col-12 col-md-6 mb-3 mb-md-5"><BuyInFilter filterTournaments={filterTournaments}/></div>
                <div className="col-12 col-md-6 mb-5"><SearchForm searchStr={data.searchStr} handleSearch={handleSearch} handleSubmit={handleSubmit}/></div>
            </div>
            <TournamentsTable tournaments={data.tournaments} pokerSites={data.pokerSites}/>
        </div>
    )
}

export default App;